export default __webpack_public_path__ + "static/media/banner1.339bbe7b.jpg";